<template>
  <div>
    <div @click="clickj" class="addressInput">
      <h4>{{ point.name }}</h4>
      <p>{{ point.address }}</p>
      <div class="btns">
        <a @click.stop="openUpdate" v-if="noUpdate != true">修改</a>
        <slot name="btn"></slot>
      </div>
    </div>


    <form-model :mask-closable="false" :closable="false" title="修改地址" width="700" ref="formModel">
      <div id="map111" slot="topcontent"></div>
      <Button slot="btn" type="primary" @click="ok">提交表单</Button>
    </form-model>
  </div>
</template>
<script>
var map;
var mouseTool;
export default {
  props: ["value", "lng", "lat", "noUpdate"],
  data() {
    return {
      name: "",
      address: "",
      openForm: false,
      point: {
        x: 114.0002,
        y: 22.0001,
        address: "",
        name: "",
        type: "",
      },
      forms: [{
        title: "地址简称",
        key: "name",
        required: true,
        span: 24,
        type: "Input",
      }, {
        title: "详细地址",
        key: "address",
        required: true,
        span: 24,
        type: "Input",
      },]
    };
  },
  methods: {
    clickj() {
      this.$emit("on-click");
    },
    split(v) {
      if (v) {
        var a = v.split("_");
        this.point.name = a[0];
        this.point.address = a[1];
      }
    },
    openUpdate(v) {
     
      setTimeout(() => {
        this.gMap();
        this.$refs.formModel.reach(this.forms, this.point);
      }, 200);
    },
    gMap() {
      map = new AMap.Map("map111", {
        resizeEnable: true,
        zoom: 18,
        center: [this.point.x, this.point.y],
      });
      mouseTool = new AMap.MouseTool(map);
      this.oldMarker();
    },
    oldMarker() {
      map.clearMap();
      var marker = new AMap.Marker({
        offset: new AMap.Pixel(-8, -30),
        position: [this.point.x, this.point.y],
        draggable: true,
        cursor: "move",
        raiseOnDrag: true,
      });

      var that = this;
      //拖动后放手
      AMap.event.addListener(marker, "mouseup", function (e) {
        var p = marker.getPosition();
        that.point.x = p.lng;
        that.point.y = p.lat;
        map.panTo(p);
      });
      marker.setMap(map);
      //map.setFitView();
    },
    ok() {
      var a = this.$refs.formModel.getItem();
      if (!a) {
        return;
      }
      this.$refs.formModel.close();
      this.$emit("ok", this.point);
    },
  },
  mounted() {
    this.split(this.value);
    this.point.x = this.lng;
    this.point.y = this.lat;
  },
  watch: {
    value(v) {
      this.split(v);
    },
    lng(v) {
      this.point.x = v;
    },
    lat(v) {
      this.point.y = v;
    },
  },
};
</script>
<style>
.addressInput {
  width: 100%;
  min-height: 40px;
  border: solid 1px #ccc;
  padding: 4px;
  line-height: 1;
  position: relative;
}

.addressInput>.btns {
  position: absolute;
  top: 2px;
  right: 2px;
  display: inline-block;
  background: white;
  display: none;
}

.addressInput:hover>.btns {
  display: block;
}

.addressInput h4 {
  font-weight: bold;
  margin-bottom: 4px;
}

.addressInput p {
  line-height: 1.3;
}

.addressInput:hover {
  background: #e0f5ff;
  cursor: pointer;
}

#map111 {
  width: 100%;
  height: 300px;
  background: gray;
  margin-bottom: 30px;
}
</style>


// WEBPACK FOOTER //
// ../common/src/components/address.vue